import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'article-related-articles',
  styleUrl: 'article-related-articles.css',
  shadow: false,
})
export class ArticleRelatedArticles {
  /**
   * Cards Data
   */
  @Prop() cardsData: string;
  /**
   * Main Title
   */
  @Prop() mainTitle: string;

  @Element() el: HTMLElement;
  private isSticky = false;
  private isAtBottom = false;

  navScroll() {
    //check if nav needs to be stopped
    const sideNav = this.el.querySelector('.blog-side-nav') as HTMLElement;
    const flexibleContent = document.querySelector('.article-content-wrapper') as HTMLElement;

    const navTop = sideNav.offsetTop;
    const navHeight = sideNav.offsetHeight;
    const contentBottom = flexibleContent.offsetTop + flexibleContent.offsetHeight;

    if (!this.isSticky && window.scrollY >= navTop) {
      sideNav.style.position = 'sticky';
      this.isSticky = true;
    } else if (this.isSticky && window.scrollY < navTop) {
      sideNav.style.position = 'static';
      this.isSticky = false;
    }

    if (!this.isAtBottom && window.scrollY >= contentBottom - navHeight) {
      // sideNav.style.position = 'absolute';
      sideNav.style.top = `-300px`;
      this.isAtBottom = true;
    } else if (this.isAtBottom && window.scrollY < contentBottom - navHeight) {
      sideNav.style.position = 'sticky';
      this.isAtBottom = false;
    }
  }

  sideNavigation() {
    window.onscroll = () => this.navScroll();
  }

  componentDidLoad() {
    // window.setTimeout(() => {
    //   this.sideNavigation();
    // }, 300);
    addIntersectionObserver(
      this.el.querySelector('.blog-side-nav'),
      () => {
        this.el.querySelector('.blog-side-nav').classList.add('animate');
      },
      ['.overlay1'],
    );
  }
  render() {
    const cards = JSON.parse(this.cardsData);
    const count = cards.length;
    return (
      <Host>
        <div class={`flex flex-col gap-12px blog-side-nav`}>
          <div class={`overlay1`}></div>
          <h2 class={`fs-0 text-ui-gray-1 font-semibold border-b-2 border-ui-gray-6 pb-12px`}>{this.mainTitle}</h2>
          <div class={`related-article-container blog-side-nav-container-mobile`}>
            {cards.length > 0 &&
              cards.map(({ title, category, image_url, image_alt, link }) => (
                <div class={`related-article-item flex flex-row items-center justify-start text-start flex-grow rounded-xl card gap-12px group `}>
                  <div class="card-image-container relative overflow-hidden">
                    {image_url && <image-block imageUrl={image_url} imageAlt={image_alt} imageClass={`card-image`}></image-block>}
                    {/* {image_url && <img src={image_url} alt={image_alt} class={`card-image`} />} */}
                  </div>
                  <div class={`card-text-container`}>
                    {category && <p class={`text-ui-gray-2 fs--1 capitalize mb-8px`}>{category}</p>}
                    {title && <h3 class={`card-title line-clamp-2 text-ui-gray-1 font-medium fs--1`}>{title}</h3>}
                    {link && count > 1 ? <div class={`card-link `}></div> : <div class={`learn-more-btn`}>Learn more</div>}
                  </div>
                  <a class={`card-overlay`} href={link}></a>
                </div>
              ))}
          </div>
        </div>
        <slot></slot>
      </Host>
    );
  }
}
